import(/* webpackMode: "eager", webpackExports: ["MainLayout"] */ "/workspace/components/layout/main-layout.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
